import React, { useState } from "react";

const FilterContext = React.createContext({
  sorting: { id: "", name: "", direction: "" },
  paginating: { page: 1 },
  customFiltering: {
    gestPaie: "",
    direction: "",
    service: "",
    statutRivp: "",
    typeDemande: "",
  },
  nameFiltering: {
    aTraiter: "",
    enCours: "",
    traitees: "",
  },
  areFiltersLoaded: false,
  sort: (selectedColumn, sortDirection) => {},
  paginate: (page) => {},
  customFilter: (customFilter, filterType) => {},
  nameFilter: (filterValue, filterType) => {},
  resetFilters: () => {},
  resetNameFilter: (filterType) => {},
});

export const FilterContextProvider = (props) => {
  const [sorting, setSorting] = useState({
    id: "date",
    name: "",
    direction: "asc",
  });
  const [paginating, setPaginating] = useState({ page: 1 });
  const [customFiltering, setCustomFiltering] = useState({
    gestPaie: "",
    direction: "",
    service: "",
    statutRivp: "",
    typeDemande: "",
  });
  const [nameFiltering, setNameFiltering] = useState({
    aTraiter: "",
    enCours: "",
    traitees: "",
  });
  const [areFiltersLoaded, setAreFiltersLoaded] = useState(false);

  const sortingHandler = (selectedColumn, sortDirection) => {
    setSorting({
      id: selectedColumn.id,
      name: selectedColumn.name,
      direction: sortDirection,
    });
  };

  const paginatingHandler = (page) => {
    setPaginating({ page: page });
  };

  const customFilteringHandler = (customFilter, filterType) => {
    setAreFiltersLoaded(true);
    if (filterType === "gestPaie") {
      setCustomFiltering((prevState) => {
        return { ...prevState, gestPaie: customFilter };
      });
    } else if (filterType === "direction") {
      setCustomFiltering((prevState) => {
        return { ...prevState, direction: customFilter };
      });
    } else if (filterType === "service") {
      setCustomFiltering((prevState) => {
        return { ...prevState, service: customFilter };
      });
    } else if (filterType === "statutRivp") {
      setCustomFiltering((prevState) => {
        return { ...prevState, statutRivp: customFilter };
      });
    } else if (filterType === "typeDemande") {
      setCustomFiltering((prevState) => {
        return { ...prevState, typeDemande: customFilter };
      });
    } else {
      setCustomFiltering({
        gestPaie: "",
        direction: "",
        service: "",
        statutRivp: "",
        typeDemande: "",
      });
    }
  };

  const nameFilteringHandler = (filterValue, filterType) => {
    if (filterType === "aTraiter") {
      setNameFiltering((prevState) => {
        return { ...prevState, aTraiter: filterValue };
      });
    } else if (filterType === "enCours") {
      setNameFiltering((prevState) => {
        return { ...prevState, enCours: filterValue };
      });
    } else if (filterType === "traitees") {
      setNameFiltering((prevState) => {
        return { ...prevState, traitees: filterValue };
      });
    } else {
      setNameFiltering({
        aTraiter: "",
        enCours: "",
        traitees: "",
      });
    }
  };

  const resetFilterHandler = () => {
    setSorting({ id: "", name: "", direction: "" });
    setPaginating({ page: 1 });
    setCustomFiltering({
      gestPaie: "",
      direction: "",
      service: "",
      statutRivp: "",
      typeDemande: "",
    });
    resetFilterHandler();
    setAreFiltersLoaded(false);
  };

  const resetNameFilterHandler = (filterType) => {
    if (filterType === "aTraiter") {
      setNameFiltering((prevState) => {
        return { ...prevState, aTraiter: "" };
      });
    } else if (filterType === "enCours") {
      setNameFiltering((prevState) => {
        return { ...prevState, enCours: "" };
      });
    } else if (filterType === "traitees") {
      setNameFiltering((prevState) => {
        return { ...prevState, traitees: "" };
      });
    }
  };

  const contextValue = {
    sorting: sorting,
    paginating: paginating,
    customFiltering: customFiltering,
    areFiltersLoaded: areFiltersLoaded,
    nameFiltering: nameFiltering,
    sort: sortingHandler,
    paginate: paginatingHandler,
    customFilter: customFilteringHandler,
    nameFilter: nameFilteringHandler,
    resetFilter: resetFilterHandler,
    resetNameFilter: resetNameFilterHandler,
  };

  return (
    <FilterContext.Provider value={contextValue}>
      {props.children}
    </FilterContext.Provider>
  );
};

export default FilterContext;
